/**
 * @Author:      
 * @DateTime:    
 * @Description: 后台-登录页管理
 */
'use strict';
angular.module("loginMangementModule", [
	'loginPageMangementModule',
	'setSubdomainsMgrModule',
	'loginPageMangementServiceModule',
	'setSuccessModule',
	'smsMgrModule'
]).
controller('loginMangementCtrl', ['$scope', '$validation', 'httpService', '$filter', '$state', 'modalDialog', 'Upload', '$timeout', "$q", "loginPageMangementService", function($scope, $validation, httpService, $filter, $state, modalDialog, Upload, $timeout, $q, loginPageMangementService) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {
			currentIndex: 0,
			isHasBackGround:true,
		};
		$scope.data = {
			platformLogo: [],
			backGroundType: 1,
			platformBackGround: [],
			platformName: ''
		};
	}
	/**
	 * [initData description] 初始化数据
	 * @return {[type]} [description]
	 */
	function initData() {
		requestData();
	}
	/**
	 * [uploadPices description]上传logo
	 * 
	 * @param  {[type]} $files [description]
	 * @return {[type]}        [description]
	 */
	$scope.uploadLogo = function(files, file, newFiles) {
		if(!newFiles) return;
		if(newFiles[0].$error) {
			modalDialog.alertType("", "请选择正确的图片格式，重新上传", "error", false);
		}else{
			uploadImages(files).then(function(url) {
				loginPageMangementService.newCropperBg(url, "118,118", '118,118').then(function(data) {
					$scope.data.platformLogo[0] = data.imgSrc;
				});
			}).catch(function(error){
				modalDialog.alertType("上传失败", error.data.message, "error", false);
			});
		}
	};
	/**
	 * [deleteItem description]删除背景图片
	 * @return {[type]} [description]
	 */
	$scope.deleteItem = function(index) {
		$scope.data.platformBackGround.splice(index, 1);
	};

	$scope.deleteLogo = function() {
		$scope.data.platformLogo.splice(0, 1);
	};
	/**
	 * [uploadBackImg description]上传背景
	 * @param  {[type]} files    [description]
	 * @param  {[type]} file     [description]
	 * @param  {[type]} newFiles [description]
	 * @param  {[type]} index    [description]
	 * @return {[type]}          [description]
	 */
	$scope.uploadBackImg = function(files, file, newFiles) {
		if(!newFiles) return;
		if(newFiles[0].$error) {
			modalDialog.alertType("", "请选择正确的图片格式，重新上传", "error", false);
		}else{
			uploadImages(newFiles).then(function(url) {
				loginPageMangementService.newCropperLogin(url, "260,118", '1366,768').then(function(data) {
					$scope.data.platformBackGround.push(data.imgSrc);
				});
			}).catch(function(error){
				modalDialog.alertType("上传失败", error.data.message, "error", false);
			});
		}

	};
	/**
	 * [uploadImages description] 上传图片 
	 * @return {[type]} [description]
	 */
	function uploadImages(newFiles) {
		var deffer = $q.defer();
		if(newFiles.length != 0) {
			Upload.upload({
				url: "/mcnadmin/upload/image.do",
				headers:{requestToken:sessionStorage.getItem('requestToken')},
				data: {
					file: newFiles
				},
			}).then(function(resp) {
				if(resp.data.success == true) {
					deffer.resolve(resp.data.url);
				}else{
					deffer.reject(resp);
				}
			});
			return deffer.promise;
		}
	}
	/**
	 * [description]切换图片
	 * @return {[type]} [description]
	 */
	$scope.changPic = function(des) {
		if(des == 'next') {
			$scope.status.currentIndex++;
			$scope.status.currentIndex = ($scope.status.currentIndex + 1) > $scope.data.platformBackGround.length ? 0 : $scope.status.currentIndex;
		} else {
			$scope.status.currentIndex--;
			$scope.status.currentIndex = $scope.status.currentIndex >= 0 ? $scope.status.currentIndex : $scope.data.platformBackGround.length - 1;
		}
	};
	/**
	 * [refresh description]刷新按钮
	 * @return {[type]} [description]
	 */
	$scope.refresh = function() {
		// $scope.status.platformLogo = angular.copy($scope.data.platformLogo);
		// $scope.status.platformBackGround = angular.copy($scope.data.platformBackGround);
		// $scope.status.platformName = angular.copy($scope.data.platformName);
		// handeEmptyEle($scope.status.platformBackGround);
		// $scope.status.currentIndex = 0;
	};
	/**
	 * [save description] 保存
	 * @return {[type]} [description]
	 */
	$scope.save = function() {
		$validation.validate($scope.loginMgrForm).success(function() {
			var params = angular.copy($scope.data);
			if($scope.data.backGroundType == 1 && params.platformBackGround.length == 0){
				$scope.status.isHasBackGround = false;
			}else{
				handeEmptyEle(params.platformBackGround);
				params.platformBackGround = JSON.stringify(params.platformBackGround);
				params.platformLogo = JSON.stringify(params.platformLogo);
				httpService.http("/mcnadmin/admin/tenant/editPlatformPage.do", params, "post").then(function(data) {
					modalDialog.alertType("", "保存成功", "success", false, function() {
						location.reload();
					});
				});
			}
		}).error(function() {
		});
	};
	/**
	 * [handeEmptyEle description] 处理元素中的空元素
	 * @return {[type]} [description]
	 */
	function handeEmptyEle(array) {
		for(var i = array.length; i >= 0; i--) { //处理空行问题
			var picUrl = array[i];
			if(!picUrl) {
				array.splice(i, 1);
			}
		}
	}
	/**
	 * [requestData description]获得初始化数据
	 * @return {[type]} [description]
	 */
	function requestData() {
		var deffer = $q.defer();
		httpService.http("/mcnadmin/admin/tenant/getCurrTenantConfig.do", "", "post").then(function(res) {
			var data = res.data;
			if(data.platformlogo==null){
				$scope.data.platformLogo.push("./login/trsCarouselFigure/images/logo.png");
			}else{
				$scope.data.platformLogo = JSON.parse(data.platformlogo);
			}
			if(data.platformName==null){
				$scope.data.platformName = '新疆吉木萨尔县内容开发平台';
			}else{
				$scope.data.platformName = data.platformName;
			}
			if(data.backGroundType) {
				$scope.data.platformBackGround = JSON.parse(data.platformBackGround);
				$scope.data.backGroundType = data.backGroundType;
			} else {
				$scope.data.backGroundType = 0;
				$scope.data.platformBackGround = ["./login/trsCarouselFigure/images/bg.jpg"];
			}
			$scope.refresh();
			deffer.resolve();
		});
		return deffer.promise;
	}
	/**
	 * [setDefaultPic description] 使用默认图片
	 */
	$scope.setDefaultPic = function() {
		setDefaultPic();
	};
	/**
	 * [setDefaultPic description]使用默认图片
	 */
	function setDefaultPic() {
		$scope.data.backGroundType = 0;
		$scope.data.platformBackGround = ["./login/trsCarouselFigure/images/bg.jpg"];
	}
	/**
	 * [setCustomPic description] 使用自定义图片
	 */
	$scope.setCustomPic = function() {
		$scope.data.backGroundType = 1;
		$scope.data.platformBackGround = [];
	};
}]);